import PublicationNotice from "./PublicationNotice";
import { useTextTranslation } from "../../utils/useTextTranslation";
import { isComingSoon } from "../../utils/publication";
import { TRACK_IDS } from "../../analytics/trackIds";
import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState
} from "react";
import { useParams, NavLink, useHistory, useLocation } from "react-router-dom";
import { SessionContext } from "../../context/SessionContext";
import {
  getContentById,
  getTrailerPlayUrlById,
  getVodPlayUrlById,
  getRecommendationsForVod
} from "../../api/vod/vod";
import useQuery from "../../utils/useQuery";
import { prettyTimeFormatter } from "../../utils/prettyTimeFormatter";
import getParentalAdvisoryElements from "../../utils/getParentalAdvisory";
import {
  getTrailerAudioOnGlobal,
  setTrailerAudioOnGlobal,
  setWhereFrom
} from "../../statics/config";
import { getPosterUrlByType } from "../../utils/findPoster";
import localizationStrings from "../../statics/localization";
import Modal from "../modal/Modal";
import ImageView from "../imageView";
import RelatedVodCarousel from "./RelatedVodCarousel";
import { LoadingState, ErrorState } from "../status/StatusView";
import { loadRequest } from "../../utils/loadRequest";
import TrailerPlayer from "../trailerPlayer";
import VideoPlayer from "../videoPlayer/VideoPlayer";
import FavoriteAction from "../favoriteAction";
import LikeAction from "../likeAction";
import ShareAction from "../ShareAction/ShareAction";
import Payment from "../payment/Payment";
import RentalOptions from "./RentalOptions";
import { rentalCopy } from "../../api/mw/rental";
import Notification from "../notification";
import defaultDetailPoster from "../../assets/images/default-vod-horizontal-poster.png";
import defaultCastPoster from "../../assets/images/default-cast-poster.png";
import mainLoadingGif from "../../assets/loading.gif";
import StarIcon from "../../assets/icons/svg/StarIcon";
import RtukAgeIcon from "../../assets/icons/svg/RtukAgeIcon";
import RtukGeneralIcon from "../../assets/icons/svg/RtukGeneralIcon";
import RtukSevenAgeIcon from "../../assets/icons/svg/RtukSevenAgeIcon";
import RtukThirteenAgeIcon from "../../assets/icons/svg/RtukThirteenAgeIcon";
import SinglePlayIcon from "../../assets/icons/svg/SinglePlayIcon";
import NewEpisodeItem from "../newEpisodeItem/NewEpisodeItem";
import PackageIcon from "../../assets/icons/svg/PackageIcon";
import BigLockIcon from "../../assets/icons/svg/BigLockIcon";
import AudioOnIcon from "../../assets/icons/svg/AudioOnlIcon";
import AudioOffIcon from "../../assets/icons/svg/AudioOffIcon";

const playerOptions = {
  // fill: true,
  fluid: true,
  responsive: true,
  preload: "auto",
  controls: true,
  liveui: false,
  autoplay: true,
  playbackRates: [0.5, 1, 1.5, 2],
  disablePictureInPicture: false,
  controlBar: {
    pictureInPictureToggle: true
  },
  html5: {
    nativeTextTracks: true,
    dash: {
      useTTML: true
    }
  }
};

const NewVodDetail = ({ scrollRef }) => {
  const translateText = useTextTranslation();
  const alive = useRef(true);
  const timers = useRef(new Set());
  const episodeRequest = useRef(0);
  const playPending = useRef(false);
  const [resumeRefreshing, setResumeRefreshing] = useState(false);
  const [contentError, setContentError] = useState(null);
  const [playError, setPlayError] = useState(false);
  const [expandedSynopsis, setExpandedSynopsis] = useState(false);
  const [canExpandSynopsis, setCanExpandSynopsis] = useState(false);
  const synopsisRef = useRef(null);
  const detailRef = useRef(null);
  const hadPlayer = useRef(false);
  const location = useLocation();
  const later = (callback, delay) => {
    const timer = window.setTimeout(async () => {
      timers.current.delete(timer);
      if (!alive.current) return;
      try {
        await callback();
      } catch (error) {
        /* Optional bookmark refresh can be retried on the next visit. */
      }
    }, delay);
    timers.current.add(timer);
    return timer;
  };
  useLayoutEffect(
    () => () => {
      alive.current = false;
      timers.current.forEach(clearTimeout);
    },
    []
  );
  // Video Player States
  const [isPlay, setIsPlay] = useState(true);
  const [playUrl, setPlayUrl] = useState("");
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);
  const [trailerPlayUrl, setTrailerPlayUrl] = useState(null);
  const [isAudioOn, setIsAudioOn] = useState(getTrailerAudioOnGlobal());
  const [thumbnails, setThumbnails] = useState([]);

  // Media Assets
  const [posterUrl, setPosterUrl] = useState(null);
  const [isContentLoading, setIsContentLoading] = useState(true);
  const [posterLoadError, setPosterLoadError] = useState(false);

  const [verticalPosterPath, setVerticalPosterPath] = useState(null);

  // VOD & Episode Data
  const [vod, setVod] = useState(null);
  const [seasons, setSeasons] = useState(null);
  const [episodes, setEpisodes] = useState(null);
  const [selectSeason, setSelectSeason] = useState(null);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedEpisode_, setSelectedEpisode_] = useState(null);

  //Binge Watching Data
  const [nextEpisode, setNextEpisode] = useState(null);
  const [nextSeason, setNextSeason] = useState(null);

  // Bookmarks
  const [bookmarkTime, setBookmarkTime] = useState(null);
  const [serieBookmark, setSerieBookmark] = useState(null);
  const [bookmarkUpdateTrigger, setBookmarkUpdateTrigger] = useState(0);

  // UI State
  const [showLoading, setShowLoading] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [showWatchNow, setShowWatchNow] = useState(false);
  const [paymentResult, setPaymentResult] = useState(null);
  const [selectedTab, setSelectedTab] = useState("details");
  const [showNotInProduct, setShowNotInProduct] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [recommendedVods, setRecommendedVods] = useState([]);

  // Purchase
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [rentalContent, setRentalContent] = useState(null);
  const [showRentalOptions, setShowRentalOptions] = useState(false);
  const accessCopy = rentalCopy();

  // Refs (For Flags / Persistent State)
  const vodRef = useRef(null);
  const seasonsRef = useRef(null);
  const episodesRef = useRef(null);
  const trailerUrlRef = useRef(null);
  const nextEpisodeRef = useRef(null);
  const selectedSeasonRef = useRef(null);
  const bookmarkedEpisode = useRef(null);
  const bookmarkedSeason = useRef(null);
  const nextSeasonEpisodesRef = useRef([]);
  const manuallySetNextEpisode = useRef(false); // Flag to prevent overriding manually set next episode

  // Route & Query Params
  let { vodId } = useParams();
  const history = useHistory();
  let isPipPlay = useQuery().get("pipPlay") === "1";
  let isDirectlyPlay = useQuery().get("play") === "1";
  let episodeIdFromUrl = useQuery().get("episodeId");
  let seasonIdFromUrl = useQuery().get("seasonId");
  let bookmarkTimeFromUrl = parseInt(useQuery().get("bookmarkTime")) || 0;

  // Session Context
  const {
    path,
    userFrameConfig,
    userInfo,
    setShowLoginMessage,
    showLoginMessage,
    hasLoggedIn,
    profile
  } = useContext(SessionContext);

  ///// functions /////
  const setPosters = (posters = []) => {
    // Get poster URLs using exact type strings
    const verticalPosterUrl = getPosterUrlByType(posters, "Web Portrait");
    const bannerPosterUrl = getPosterUrlByType(posters, "Web Banner");
    const landscapePosterUrl = getPosterUrlByType(posters, "Web Landscape");

    if (verticalPosterUrl) {
      setVerticalPosterPath(verticalPosterUrl);
    }

    // Prioritize banner, fallback to landscape
    const mainPosterUrl = bannerPosterUrl || landscapePosterUrl || null;
    setPosterUrl(mainPosterUrl);
  };

  const processSerialSeasons = (seriesData, directlyPlay = false) => {
    const _seasons = seriesData.children;
    seasonsRef.current = _seasons;

    setSeasons(_seasons);
    let lastSelectedSeasonIndex = null;
    const contentInfo = seriesData.lastContentInfo;

    // Check if we have season ID from URL (from mini modal)
    if (seasonIdFromUrl) {
      lastSelectedSeasonIndex = _seasons.findIndex(
        (season) => season?.id === seasonIdFromUrl
      );
    } else if (selectedSeason?.id) {
      lastSelectedSeasonIndex = _seasons.findIndex(
        (season) => season?.id === selectedSeason.id
      );
    } else if (contentInfo) {
      lastSelectedSeasonIndex = _seasons.findIndex(
        (season) => season?.seasonNo === contentInfo?.lastContentSe
      );
    }

    let _selectSeason = null;
    if (lastSelectedSeasonIndex && lastSelectedSeasonIndex > 0) {
      _selectSeason = _seasons[lastSelectedSeasonIndex];
    } else {
      _selectSeason = _seasons[0];
    }
    selectedSeasonRef.current = _selectSeason;
    setSelectedSeason(_selectSeason);
    return getEpisodes(_selectSeason?.id, (_episodes) => {
      if (_episodes && _episodes.length > 0) {
        // Check if we have episode ID from URL (from mini modal)
        if (episodeIdFromUrl) {
          bookmarkedEpisode.current = _episodes.find((episode) => {
            return episode?.id === episodeIdFromUrl;
          });
          if (bookmarkedEpisode.current) {
            bookmarkedSeason.current = {
              ..._selectSeason,
              children: _episodes
            };
            // Set bookmark time from URL if provided
            if (bookmarkTimeFromUrl > 0) {
              setBookmarkTime(bookmarkTimeFromUrl);
            }
          }
        } else if (contentInfo && !manuallySetNextEpisode.current) {
          // Only use server's lastContentInfo if we haven't manually set the next episode
          // Fallback to default content info
          bookmarkedEpisode.current = _episodes.find((episode) => {
            return episode?.id === contentInfo?.lastContentId;
          });

          if (bookmarkedEpisode.current) {
            bookmarkedSeason.current = {
              ..._selectSeason,
              children: _episodes
            };
          }
        }

        if (directlyPlay) {
          if (bookmarkedEpisode.current) {
            continueWatchingEpisode();
          } else {
            playFirstEpisode();
          }
        }
      }
    });
  };

  const calcDuration = () => {
    if (vod?.type === "MOVIE") {
      return prettyTimeFormatter(vod?.duration);
    } else if (vod?.type === "SERIES") {
      return `${vod?.children?.length + " " + localizationStrings.season}`;
    }
  };

  const playFirstEpisode = () => {
    if (episodesRef?.current?.[0]) {
      findNextEpisode(episodesRef.current[0]);
      getPlayUrl(episodesRef.current[0]);
    } else {
      getPlayUrl();
    }
  };

  const continueWatchingEpisode = () => {
    if (!bookmarkedSeason.current) return; //TO DO: season not found pop up
    selectedSeasonRef.current = bookmarkedSeason.current;
    setSelectedSeason(bookmarkedSeason.current);

    const items = bookmarkedSeason.current?.children;
    if (!(Array.isArray(items) && items.length > 0)) return; //TO DO: episodes not found pop up
    episodesRef.current = items;
    setEpisodes(items);

    onSelectEpisode(bookmarkedEpisode.current);
  };

  const onSelectEpisode = (item) => {
    findNextEpisode(item);
    setBookmarkTime(item?.lastDuration);
    getPlayUrl(item);
    bookmarkedEpisode.current = null;
    bookmarkedSeason.current = null;
    manuallySetNextEpisode.current = false; // Reset flag when user manually selects episode
  };

  const findNextEpisode = (item) => {
    const activeEpisode = item;
    setNextSeason(false);
    setSelectedEpisode_(item);
    if (!Array.isArray(episodesRef.current)) return;
    let selectedEpisodeIndex = episodesRef.current.findIndex(
      (item) => item.id === activeEpisode.id
    );
    if (selectedEpisodeIndex + 1 < episodesRef.current.length) {
      nextEpisodeRef.current = episodesRef.current[selectedEpisodeIndex + 1];
      setNextEpisode(episodesRef.current[selectedEpisodeIndex + 1]);
    } else if (selectedEpisodeIndex + 1 === episodesRef.current.length) {
      findNextSeason();
    }
  };
  const findNextSeason = () => {
    const _seasons = seasonsRef.current;
    let selectedSeasonIndex = _seasons.findIndex(
      (item) => item.seasonNo === selectedSeasonRef.current?.seasonNo
    );

    if (selectedSeasonIndex + 1 < _seasons.length) {
      setNextSeason(_seasons[selectedSeasonIndex + 1]);
      getNextSeasonWithFirstEpisode(_seasons[selectedSeasonIndex + 1].id); //for next season
    } else {
      nextEpisodeRef.current = null;
      setNextEpisode(null);
    }
  };

  const watchNow = async () => {
    setShowWatchNow(false);
    if (vodRef.current?.type === "SERIES" && rentalContent?.id) {
      await getContent();
      getPlayUrl(rentalContent);
    } else {
      getContent(true);
    }
  };

  const watchLater = () => {
    setShowWatchNow(false);
    getContent();
  };

  const handleToggleAudio = () => {
    const newAudioState = !isAudioOn;
    setIsAudioOn(newAudioState);
    setTrailerAudioOnGlobal(newAudioState);
  };
  /////End: functions /////

  ///// render function /////
  const openRental = (content, offer) => {
    setRentalContent(content);
    setSelectedProduct(offer);
    setShowRentalOptions(false);
    setShowPayment(true);
  };
  const renderAccessActions = (content) => {
    if (isComingSoon(content)) return <PublicationNotice item={content} compact />;
    if (content?.isUnlocked === false && hasLoggedIn) {
      return content.products?.length ? (
        <RentalOptions content={content} onSelect={openRental} disabled={showLoading} />
      ) : (
        <div className="vod-access-notice">
          <p role="status">{content.purchaseUnavailable ? accessCopy.purchaseUnavailable : accessCopy.unavailable}</p>
        </div>
      );
    }
    return null;
  };
  const renderActionButtons = (_vod, _episodes) => {
    if (isComingSoon(_vod)) return (
      <PublicationNotice item={_vod} trailerUnavailable={!trailerPlayUrl} />
    );
    // Use the same episode as the play/resume action, not the series representative.
    const content = _vod?.type === "SERIES"
      ? bookmarkedEpisode.current || _episodes?.[0]
      : _vod;
    const accessActions = renderAccessActions(content);
    if (accessActions) return accessActions;
    else {
      return (
        <button
          type="button"
          disabled={showLoading || resumeRefreshing || isContentLoading ||
            (vod?.type === "SERIES" && !episodes?.length)}
          data-track-id={TRACK_IDS.DETAIL_PLAY}
          className="play-button"
          onClick={() => {
            if (vodRef.current?.type === "MOVIE") {
              getPlayUrl();
            } else {
              if (bookmarkedEpisode.current) {
                continueWatchingEpisode();
              } else {
                playFirstEpisode();
              }
            }
          }}
        >
          <div
            className="icon"
            style={{ marginRight: showLoading ? "6px" : "" }}
          >
            {showLoading ? (
              <div className="loading-gif">
                <img src={mainLoadingGif} />
              </div>
            ) : (
              <SinglePlayIcon />
            )}
          </div>
          <span>
            {serieBookmark || (bookmarkTime && bookmarkTime !== 0)
              ? localizationStrings.continue
              : localizationStrings.play}{" "}
            {_vod?.type === "SERIES" && _episodes?.length
              ? `S${
                  bookmarkedEpisode.current?.seasonNo ??
                  _episodes?.[0]?.seasonNo
                }${localizationStrings.shortEpisode}${
                  bookmarkedEpisode.current?.episodeNo ??
                  _episodes?.[0]?.episodeNo
                }`
              : _vod?.type === "SERIES" ? "" : ` ${localizationStrings.movie}`}
          </span>
        </button>
      );
    }
  };
  /////End: render function /////

  ///// async functions /////

  const getContent = async (directlyPlay = false) => {
    if (!vodId) return;
    if (!alive.current) return;
    setContentError(null);
    setIsContentLoading(true);
    setPosterLoadError(false);
    setPosterUrl(null);
    try {
      const { data } = await loadRequest((options) =>
        getContentById(vodId, options)
      );
      if (!alive.current) return;
      if (!data?.id || typeof data.title !== "string")
        throw new Error("INVALID_CONTENT");
      if (!directlyPlay || isComingSoon(data)) {
        getTrailerUrl(data.id);
      }
      setPosters(data.posters);
      vodRef.current = data;
      setVod(data);

      if (data?.type === "SERIES" && data?.children) {
        setSelectedTab("episodes");
        await processSerialSeasons(data, directlyPlay);
      } else {
        // Handle movie bookmarks
        let bookmarkTimeToUse = 0;

        // Prioritize bookmark time from URL (from mini modal)
        if (bookmarkTimeFromUrl > 0 && !hadPlayer.current) {
          bookmarkTimeToUse = bookmarkTimeFromUrl;
        } else {
          // Fallback to last duration from data
          const lastDuration = data.lastDuration;
          if (typeof lastDuration === "number" && !isNaN(lastDuration)) {
            bookmarkTimeToUse = lastDuration;
          }
        }

        setBookmarkTime(bookmarkTimeToUse);

        if (directlyPlay) {
          getPlayUrl();
        }
      }
    } catch (error) {
      if (alive.current) setContentError(error);
    } finally {
      if (alive.current) setIsContentLoading(false);
    }
  };

  const getTrailerUrl = async (id) => {
    try {
      const { data } = await getTrailerPlayUrlById(id);
      if (!alive.current) return;
      const url = typeof data === "string" && data.trim() ? data : null;
      trailerUrlRef.current = url;
      later(() => {
        setTrailerPlayUrl(url);
        setIsPlay(true);
      }, 500);
    } catch (err) {
      if (alive.current) setTrailerPlayUrl(null);
    }
  };

  const mapRecommendationItemToVod = (item) => {
    const id =
      item?.contentUId ||
      item?.contentUid ||
      item?.ContentUId ||
      item?.contentId ||
      item?.uid ||
      item?.id;
    const posterUrl =
      item?.posterImageUrl || item?.PosterImageUrl || item?.posterUrl || null;
    const title = item?.title || item?.Title || "";
    const type = item?.type || item?.Type || "MOVIE";
    const year = item?.year || item?.releaseYear || item?.ReleaseYear || null;
    const duration = item?.duration || item?.Duration || null;

    return {
      id,
      title,
      type,
      year,
      duration,
      posters: posterUrl
        ? [
            {
              type: "Web Portrait",
              url: posterUrl,
              posterType: "HorizontalLow",
              posterUrl: posterUrl
            },
            {
              type: "Web Landscape",
              url: posterUrl,
              posterType: "HorizontalLow",
              posterUrl: posterUrl
            }
          ]
        : []
    };
  };

  const getVodRecommendations = async (contentId) => {
    if (!contentId) {
      setRecommendedVods([]);
      return;
    }

    try {
      const { data } = await getRecommendationsForVod(contentId, 18);
      if (!alive.current) return;
      const payload = data?.Data ?? data?.data ?? data;
      const items = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.Data)
        ? payload.Data
        : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.items)
        ? payload.items
        : Array.isArray(payload?.Items)
        ? payload.Items
        : [];

      setRecommendedVods(
        items.map(mapRecommendationItemToVod).filter((item) => !!item?.id)
      );
    } catch (e) {
      if (alive.current) setRecommendedVods([]);
    }
  };

  const getEpisodes = async (seasonId, callback) => {
    if (!seasonId || !alive.current) return;
    const version = ++episodeRequest.current;
    try {
      const { data } = await loadRequest((options) =>
        getContentById(seasonId, options)
      );
      if (!alive.current || version !== episodeRequest.current) return;
      if (!data?.id || !Array.isArray(data.children))
        throw new Error("INVALID_SEASON");
      episodesRef.current = data.children;
      setEpisodes(data.children);
      if (typeof callback === "function") callback(data.children);
    } catch (error) {
      if (alive.current && version === episodeRequest.current)
        setContentError(error);
    }
  };

  const getNextSeasonWithFirstEpisode = async (seasonId) => {
    if (!seasonId) return;

    let data;
    try {
      ({ data } = await getContentById(seasonId));
    } catch (error) {
      return;
    }
    if (!alive.current) return;
    if (data?.id && data?.children) {
      const firstEpisode = data?.children[0];
      nextEpisodeRef.current = firstEpisode;
      setNextEpisode(firstEpisode);
      nextSeasonEpisodesRef.current = data?.children;
    }
  };

  const getPlayUrl = async (episodeItem = null) => {
    if (playPending.current || resumeRefreshing || !alive.current) return;
    if (isComingSoon(episodeItem || vodRef.current)) return;
    // A series representative cannot provide the selected episode's bookmark.
    if (vodRef.current?.type === "SERIES" && !episodeItem?.id && !episodesRef.current?.length) return;
    if (!hasLoggedIn) {
      if (setShowLoginMessage) setShowLoginMessage(true);
      return;
    }
    setPlayError(false);
    setWhereFrom(""); //to stop fallback from picture in picture
    let contentId = vodRef.current?.id;
    if (vodRef.current?.type === "MOVIE" || vodRef.current?.type === "SEASON") {
      contentId = vodRef.current?.id;
    } else if (vodRef.current?.type === "SERIES") {
      contentId =
        episodeItem?.id ?? episodesRef.current?.[0]?.id ?? vodRef.current?.id;
    }

    if (!contentId) {
      setShowLoading(false);
      setShowNotification(true);
      return;
    }

    playPending.current = true;
    setShowLoading(true);
    try {
      const { data } = await getVodPlayUrlById(contentId);
      if (!alive.current) return;
      if (typeof data?.url !== "string" || !data.url.trim())
        throw new Error("INVALID_PLAY_URL");
      setPlayUrl(data.url);
      setIsPlayerOpen(true);
      setIsPlay(false);
    } catch (error) {
      if (!alive.current) return;
      if (Number(error.code) === 7003) {
        // A direct link or an episode may reach playback before its current access is loaded.
        try {
          const { data: currentContent } = await getContentById(contentId);
          if (!alive.current) return;
          if (currentContent?.isUnlocked === false) {
            setRentalContent(currentContent);
            if (currentContent.products?.length) setShowRentalOptions(true);
            else setShowNotInProduct(true);
            return;
          }
        } catch (_) {
          // Keep the original playback error if refreshing the offer also fails.
        }
      }
      if (error.code === "CONTENT_UNAVAILABLE") {
        setRentalContent(error.content || null);
        if (error.content?.products?.length) setShowRentalOptions(true);
        else setShowNotInProduct(true);
      } else setPlayError(true);
    } finally {
      playPending.current = false;
      if (alive.current) setShowLoading(false);
    }
  };

  /////End: async functions /////

  ///// useEffect /////

  useEffect(() => {
    if (vodId) {
      getContent(isDirectlyPlay || isPipPlay);
      if (scrollRef && scrollRef.current) scrollRef.current.scrollTop = 0;
    }
  }, [vodId]);

  useEffect(() => {
    getVodRecommendations(vod?.id);
  }, [vod?.id]);

  useEffect(() => {
    if (selectSeason?.id) {
      selectedSeasonRef.current = selectSeason;
      setSelectedSeason(selectSeason);
      getEpisodes(selectSeason.id);
    }
  }, [selectSeason]);

  useEffect(() => {
    const scrollTarget = (scrollRef && scrollRef.current) || document;
    const handleScroll = () => {
      const scrolled =
        scrollTarget === document
          ? document.scrollingElement.scrollTop
          : scrollTarget.scrollTop;

      setIsPlay((prev) => {
        if (scrolled >= window.innerHeight / 3) {
          if (prev !== false) {
            return false;
          }
        } else {
          if (prev !== true && !isPlayerOpen) {
            return true;
          }
        }
        return prev;
      });
    };

    scrollTarget.addEventListener("scroll", handleScroll);
    return () => {
      scrollTarget.removeEventListener("scroll", handleScroll);
    };
  }, [isPlayerOpen]);

  useEffect(() => {
    if (isPlayerOpen) {
      hadPlayer.current = true;
      later(() => {
        const player =
          detailRef.current && detailRef.current.querySelector(".vod-player");
        if (player) {
          player.setAttribute("tabindex", "-1");
          player.focus({ preventScroll: true });
        }
      }, 100);
    } else if (hadPlayer.current) {
      const playButton =
        detailRef.current && detailRef.current.querySelector(".play-button");
      if (playButton) playButton.focus({ preventScroll: true });
    }
  }, [isPlayerOpen]);

  useLayoutEffect(() => {
    const synopsis = synopsisRef.current;
    if (!synopsis || expandedSynopsis) return;
    const measure = () =>
      setCanExpandSynopsis(synopsis.scrollHeight > synopsis.clientHeight + 1);
    measure();
    const observer =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(measure)
        : null;
    if (observer) observer.observe(synopsis);
    window.addEventListener("resize", measure);
    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [vod?.summaryLong, expandedSynopsis, contentError]);

  /////End: useEffect /////
  const related = Array.from(
    new Map(
      [
        ...(Array.isArray(vod?.relatedContents) ? vod.relatedContents : []),
        ...recommendedVods
      ]
        .filter((item) => item?.id && item.id !== vodId)
        .map((item) => [item.id, item])
    ).values()
  );
  if (isContentLoading && !vod)
    return (
      <div className="vod-modal-status">
        <h1 id="vod-modal-title" className="sr-only">
          {localizationStrings.details}
        </h1>
        <LoadingState size="section" />
      </div>
    );
  if (contentError)
    return (
      <div className="vod-modal-status">
        <h1 id="vod-modal-title" className="sr-only">
          {localizationStrings.details}
        </h1>
        <ErrorState
          size="section"
          error={contentError}
          onRetry={() => getContent()}
        />
      </div>
    );
  return (
    <div
      ref={detailRef}
      className="new-vod-detail-container"
      style={{ position: "relative" }}
    >
      <div className="new-vod-media-wrapper">
        {trailerPlayUrl && !isPlayerOpen ? (
          <TrailerPlayer
            playUrl={trailerPlayUrl}
            poster={
              !posterLoadError && posterUrl ? posterUrl : defaultDetailPoster
            }
            isAudioOn={isAudioOn}
            onAutoplayMuted={() => {
              setIsAudioOn(false);
              setTrailerAudioOnGlobal(false);
            }}
            isPlay={isPlay}
            isFrom={"newVodDetail"}
            onToggleAudio={handleToggleAudio}
          />
        ) : !isContentLoading && !posterLoadError && posterUrl ? (
          <img
            className="new-vod-poster"
            src={posterUrl}
            alt={translateText(vod?.title || "vod-poster")}
            onError={() => {
              setPosterLoadError(true);
            }}
          />
        ) : !isContentLoading ? (
          <img
            className="new-vod-poster"
            src={defaultDetailPoster}
            alt="default-detail-poster"
          />
        ) : (
          <div className="new-vod-poster loading-placeholder" />
        )}
        <div className="media-overlay">
          <div className="new-vod-metadata-container absolute">
            <h1 className="title" id="vod-modal-title">
              {translateText(vod?.title)}
            </h1>
            <div className="metadata-wrapper">
              {/* <div className="original-title">{vod?.originalTitle}</div> */}
              <div className="metadata-row">
                <div className="content-type">
                  {vod?.type === "MOVIE"
                    ? localizationStrings.searchFilters.movie
                    : vod?.type === "SERIES"
                    ? localizationStrings.series
                    : ""}
                </div>
                <div className="content-year">{vod?.year}</div>
                <div className="content-duration">{calcDuration()}</div>
              </div>
              <div className="genre-row">
                <div className="content-indicators">
                  <div className="rating">
                    {vod?.maturityRating?.age === "G" ? (
                      <RtukGeneralIcon />
                    ) : vod?.maturityRating?.age === "7+" ? (
                      <RtukSevenAgeIcon />
                    ) : vod?.maturityRating?.age === "13+" ? (
                      <RtukThirteenAgeIcon />
                    ) : vod?.maturityRating?.age === "18+" ? (
                      <RtukAgeIcon />
                    ) : null}
                  </div>
                  {getParentalAdvisoryElements(vod?.maturityRating?.categories)}
                </div>
                {vod?.genre?.map((item, index) => {
                  const uniqueKey = `${item?.id}-${index}`;
                  return (
                    <React.Fragment key={uniqueKey}>
                      <NavLink
                        className="link"
                        to={{
                          pathname: `/dashboard/search/${item}`
                        }}
                      >
                        {translateText(item)}
                      </NavLink>
                      {!(vod.genre.length - 2 < index) ? (
                        <span className="dot">
                          {`${vod.genre.length - 2 < index ? "" : " •"}`}
                        </span>
                      ) : null}
                    </React.Fragment>
                  );
                })}
                {vod?.imdbRating ? (
                  <div className="imdb-rating">
                    <span>
                      <StarIcon />
                    </span>
                    IMDb {vod?.imdbRating}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="new-vod-buttons-wrapper">
              {renderActionButtons(vod, episodes)}
              <FavoriteAction vod={vod} newVodDetail />
              <LikeAction vod={vod} newVodDetail />
              <ShareAction vod={vod} newVodDetail />
              {trailerPlayUrl && !isPlayerOpen && (
                <button
                  type="button"
                  className="vod-preview-mute"
                  onClick={handleToggleAudio}
                  aria-pressed={isAudioOn}
                  aria-label={
                    localizationStrings.getLanguage() === "arb" ? (isAudioOn ? "كتم صوت المعاينة" : "تشغيل صوت المعاينة") : localizationStrings.getLanguage() === "tr"
                      ? isAudioOn
                        ? "Ön izleme sesini kapat"
                        : "Ön izleme sesini aç"
                      : isAudioOn
                      ? "Mute preview"
                      : "Unmute preview"
                  }
                >
                  {isAudioOn ? <AudioOnIcon /> : <AudioOffIcon />}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="new-vod-details-wrapper">
        {playError && (
          <p className="vod-play-error" role="alert">
            {localizationStrings.getLanguage() === "arb" ? "تعذر تشغيل هذا المحتوى. حاول تشغيله مجددًا." : localizationStrings.getLanguage() === "tr"
              ? "İçerik şu anda oynatılamıyor. Lütfen yeniden oynatmayı dene."
              : "This title couldn’t start. Please try playing it again."}
          </p>
        )}
        {vod?.summaryLong && (
          <div className="vod-synopsis-block">
            <p
              id="vod-synopsis"
              ref={synopsisRef}
              className={`vod-modal-synopsis ${
                expandedSynopsis ? "is-expanded" : ""
              }`}
            >
              {translateText(vod.summaryLong)}
            </p>
            {canExpandSynopsis && (
              <button
                type="button"
                className="vod-synopsis-toggle"
                aria-expanded={expandedSynopsis}
                aria-controls="vod-synopsis"
                onClick={() => setExpandedSynopsis(!expandedSynopsis)}
              >
                {localizationStrings.getLanguage() === "arb" ? (expandedSynopsis ? "عرض أقل" : "قراءة المزيد") : localizationStrings.getLanguage() === "tr"
                  ? expandedSynopsis
                    ? "Daha az göster"
                    : "Devamını oku"
                  : expandedSynopsis
                  ? "Show less"
                  : "Read more"}
              </button>
            )}
          </div>
        )}
        <div className="content-info-row">
          {episodes?.length > 0 && (
            <button
              type="button"
              className={`info-tab ${
                selectedTab === "episodes" ? "selected" : ""
              }`}
              data-track-id={TRACK_IDS.DETAIL_TAB_EPISODES}
              aria-pressed={selectedTab === "episodes"}
              onClick={() => setSelectedTab("episodes")}
            >
              {localizationStrings.episodes}
            </button>
          )}
          <button
            type="button"
            className={`info-tab ${
              selectedTab === "details" ? "selected" : ""
            }`}
            data-track-id={TRACK_IDS.DETAIL_TAB_DETAILS}
            aria-pressed={selectedTab === "details"}
            onClick={() => setSelectedTab("details")}
          >
            {localizationStrings.details}
          </button>
          <button
            type="button"
            className={`info-tab ${selectedTab === "cast" ? "selected" : ""}`}
            data-track-id={TRACK_IDS.DETAIL_TAB_CAST}
            aria-pressed={selectedTab === "cast"}
            onClick={() => setSelectedTab("cast")}
          >
            {localizationStrings.cast}
          </button>
        </div>
        {selectedTab === "episodes" ? (
          <div className="season-wrapper">
            <label className="vod-season-label">
              <span>{localizationStrings.season}</span>
              <select
                data-track-id={TRACK_IDS.DETAIL_SEASON_SELECT}
                value={selectedSeason?.id || ""}
                onChange={(event) =>
                  setSelectSeason(
                    seasons.find((season) => season.id === event.target.value)
                  )
                }
              >
                {seasons?.map((season) => (
                  <option key={season.id} value={season.id}>
                    {localizationStrings.season} {season.seasonNo}
                  </option>
                ))}
              </select>
            </label>
            <div className="episodes-wrapper">
              {episodes?.map((_episode) => {
                return (
                  <NewEpisodeItem
                    key={_episode?.id}
                    episode={_episode}
                    accessActions={renderAccessActions(_episode)}
                    onSelectEpisode={(item) => {
                      if (hasLoggedIn) {
                        onSelectEpisode(item);
                      } else {
                        setShowLoginMessage(true);
                      }
                    }}
                    loading={showLoading}
                  />
                );
              })}
            </div>
          </div> // TO DO
        ) : selectedTab === "details" ? (
          <div className="details-wrapper">
            <div className="details-section">
              <div className="details-title">
                {localizationStrings.countryOfOrigin}
              </div>
              <div className="details-body">
                {translateText(vod?.country) ?? localizationStrings.noData}
              </div>
            </div>
            <div className="details-section">
              <div className="details-title">{localizationStrings.genres}</div>
              <div className="details-body">
                {vod?.genre?.map((item, index) => {
                  const uniqueKey = `${item?.id}-${index}`;
                  return (
                    <React.Fragment key={uniqueKey}>
                      <NavLink
                        className="link"
                        to={{
                          pathname: `/dashboard/search/${item}`
                        }}
                      >
                        {translateText(item)}
                      </NavLink>
                      {!(vod.genre.length - 2 < index) ? (
                        <span className="dot">
                          {`${vod.genre.length - 2 < index ? "" : " •"}`}
                        </span>
                      ) : null}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
            {vod?.actors?.length > 0 && (
              <div className="details-section">
                <div className="details-title">{localizationStrings.cast}</div>
                <div className="details-body">
                  {vod.actors
                    .slice(0, 3)
                    .map((actor) => actor.name)
                    .join(", ")}
                </div>
              </div>
            )}
          </div>
        ) : selectedTab === "cast" ? (
          <div className="casts-wrapper">
            {!vod?.actors?.length && (
              <p className="vod-empty-cast">{localizationStrings.noData}</p>
            )}
            {vod?.actors &&
              vod.actors.map((cast) => {
                return (
                  <button
                    type="button"
                    className="cast-box"
                    key={cast.id}
                    onClick={() =>
                      history.push(`/dashboard/search/${cast.name}`)
                    }
                  >
                    <ImageView
                      src={cast?.posterUrl ?? defaultCastPoster}
                      defaultPoster={defaultCastPoster}
                      borderRadius={"50%"}
                    />
                    <div className="cast-name"> {cast?.name} </div>
                  </button>
                );
              })}
          </div>
        ) : null}
        {related.length > 0 && (
          <RelatedVodCarousel key={vodId} items={related} />
        )}
      </div>
      {isPlayerOpen ? (
        <Modal viewClass={`player-modal`}>
          <VideoPlayer
            key="vod-player"
            options={playerOptions}
            src={playUrl}
            vod={vod}
            thumbnails={thumbnails}
            isTimeshiftEnable={true}
            addContentToFavorite={() => {}}
            removeContentFromFavorite={() => {}}
            setBookmarkTime={(val) => {
              setBookmarkTime(val);
            }}
            bookmarkTime={bookmarkTime}
            showAd={false}
            closePlayer={(val, saved = Promise.resolve()) => {
              if (val) {
                setResumeRefreshing(true);
                const refreshProgress = async () => {
                  await saved;
                  if (!alive.current) return;
                  if (isDirectlyPlay || isPipPlay) {
                    history.replace({
                      pathname: location.pathname,
                      search: ""
                    });
                    await getContent();
                  } else {
                    await getContent();
                    setBookmarkUpdateTrigger((prev) => prev + 1);

                    // Check if current episode was marked as completed, and update bookmark to next episode
                    const checkAndUpdateNextEpisode = async () => {
                      if (selectedEpisode_ && episodesRef.current) {
                        // Re-fetch updated episode data to check completion status
                        later(async () => {
                          if (selectedSeasonRef.current?.id) {
                            const { data } = await getContentById(
                              selectedSeasonRef.current.id
                            );
                            if (!alive.current) return;
                            if (data?.children) {
                              const updatedEpisodes = data.children;
                              const currentEpisode = updatedEpisodes.find(
                                (ep) => ep.id === selectedEpisode_.id
                              );

                              if (
                                currentEpisode &&
                                currentEpisode.lastDuration &&
                                currentEpisode.duration
                              ) {
                                // Check if episode is completed (95% watched or within last 30 seconds)
                                const isCompleted =
                                  currentEpisode.lastDuration >=
                                    currentEpisode.duration * 0.95 ||
                                  currentEpisode.duration -
                                    currentEpisode.lastDuration <=
                                    30;

                                if (isCompleted) {
                                  // Find next episode
                                  const currentIndex =
                                    updatedEpisodes.findIndex(
                                      (ep) => ep.id === selectedEpisode_.id
                                    );

                                  if (
                                    currentIndex >= 0 &&
                                    currentIndex < updatedEpisodes.length - 1
                                  ) {
                                    // Next episode in same season
                                    const nextEpisode =
                                      updatedEpisodes[currentIndex + 1];

                                    bookmarkedEpisode.current = nextEpisode;
                                    bookmarkedSeason.current = {
                                      ...selectedSeasonRef.current,
                                      children: updatedEpisodes
                                    };
                                    manuallySetNextEpisode.current = true; // Mark that we've manually set the next episode
                                    setBookmarkTime(0);
                                    setBookmarkUpdateTrigger(
                                      (prev) => prev + 1
                                    ); // Force re-render
                                  } else {
                                    // Check for next season
                                    const seasonIndex =
                                      seasonsRef.current?.findIndex(
                                        (s) =>
                                          s.id === selectedSeasonRef.current.id
                                      );

                                    if (
                                      seasonIndex >= 0 &&
                                      seasonIndex <
                                        seasonsRef.current.length - 1
                                    ) {
                                      const nextSeason =
                                        seasonsRef.current[seasonIndex + 1];

                                      const nextSeasonData =
                                        await getContentById(nextSeason.id);
                                      if (!alive.current) return;
                                      if (
                                        nextSeasonData.data?.children?.length >
                                        0
                                      ) {
                                        bookmarkedEpisode.current =
                                          nextSeasonData.data.children[0];
                                        bookmarkedSeason.current = {
                                          ...nextSeason,
                                          children: nextSeasonData.data.children
                                        };
                                        manuallySetNextEpisode.current = true; // Mark that we've manually set the next episode
                                        setBookmarkTime(0);
                                        setBookmarkUpdateTrigger(
                                          (prev) => prev + 1
                                        ); // Force re-render
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }, 1000);
                      }
                    };

                    checkAndUpdateNextEpisode();
                  }
                };
                refreshProgress().finally(() => {
                  if (alive.current) setResumeRefreshing(false);
                });

                setIsPlayerOpen(false);
                setShowLoading(false);
                if (trailerUrlRef.current) {
                  setTrailerPlayUrl(trailerUrlRef.current);
                  setIsPlay(true);
                }
              }
            }}
            nextEpisode={nextEpisode}
            nextSeason={nextSeason}
            selectedSeason={selectedSeason}
            selectedEpisode={selectedEpisode_}
            sectionInfoDetailPList={
              vod?.type === "SERIES"
                ? selectedEpisode_?.sectionInfoDetailPList || []
                : vod?.sectionInfoDetailPList || []
            }
            playNextEpisode={() => {
              if (nextSeason) {
                selectedSeasonRef.current = nextSeason;
                setSelectedSeason(nextSeason);
                episodesRef.current = nextSeasonEpisodesRef.current;
                setEpisodes(nextSeasonEpisodesRef.current);
              }

              if (!!nextEpisodeRef.current) {
                setBookmarkTime(null);
                getPlayUrl(nextEpisodeRef.current);
                findNextEpisode(nextEpisodeRef.current);
              }
            }}
            isFav={false}
            isPreview={false}
            isCutvVod={!!vod?.channelcode}
            poster={posterUrl}
          />
        </Modal>
      ) : null}
      {showWatchNow ? (
        <Notification
          text={`${paymentResult?.Simulated === true ? accessCopy.demoBilled : paymentResult?.BillingApplied === true ? accessCopy.billed : paymentResult?.BillingApplied === false ? accessCopy.accessReady : accessCopy.completed} ${localizationStrings.watchNowText}`}
          confirmText={localizationStrings.watchNow}
          notConfirmText={localizationStrings.watchLater}
          onClickConfirm={() => watchNow()}
          onClickNotConfirm={() => watchLater()}
        />
      ) : null}

      {showNotification ? (
        <Notification
          text={localizationStrings.outOfPacket}
          confirmText={localizationStrings.outOfPacketConfirm}
          confirmTrackId={TRACK_IDS.POPUP_OK}
          onClickConfirm={() => setShowNotification(false)}
        />
      ) : null}

      {showNotInProduct ? (
        <Notification
          text={
            rentalContent?.purchaseUnavailable
              ? accessCopy.purchaseUnavailable
              : accessCopy.unavailable
          }
          confirmText={localizationStrings.close}
          icon={<PackageIcon />}
          onClickConfirm={() => setShowNotInProduct(false)}
          onClickNotConfirm={() => {
            setShowNotInProduct(false);
          }}
          showCloseButton={true}
        />
      ) : null}

      {showRentalOptions && rentalContent && (
        <Modal
          viewClass="payment-modal rental-options-modal"
          label={accessCopy.choose}
          onClose={() => setShowRentalOptions(false)}
        >
          <h2>{translateText(rentalContent.title)}</h2>
          <RentalOptions content={rentalContent} onSelect={openRental} />
          <button
            type="button"
            className="not-confirm-button"
            onClick={() => setShowRentalOptions(false)}
          >
            {localizationStrings.cancel}
          </button>
        </Modal>
      )}
      {showPayment ? (
        <Payment
          key={`${rentalContent?.id}-${selectedProduct?.id}`}
          vod={rentalContent}
          product={selectedProduct}
          onRefresh={() => getContent()}
          closePayment={(watchNow, result) => {
            setShowPayment(false);
            setPaymentResult(result || null);
            setShowWatchNow(watchNow);
          }}
        />
      ) : null}
    </div>
  );
};

export default NewVodDetail;
